import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import Auth from "@/pages/Auth";
import Home from "@/pages/Home";
import Index from "@/pages/Index";
import ClientDetail from "@/pages/ClientDetail";
import Funds from "@/pages/Funds";
import FundDetail from "@/pages/FundDetail";
import Assets from "@/pages/Assets";
import Investments from "@/pages/Investments";
import AuditLogs from "@/pages/AuditLogs";
import UserManagement from "@/pages/UserManagement";
import NotFound from "@/pages/NotFound";

const protect = (el: React.ReactNode) => (
  <ProtectedRoute>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/callback" element={<Auth />} />

      {/* Protected */}
      <Route path="/" element={protect(<Home />)} />
      <Route path="/clients" element={protect(<Index />)} />
      <Route path="/client/:id" element={protect(<ClientDetail />)} />
      <Route path="/funds" element={protect(<Funds />)} />
      <Route path="/fund/:id" element={protect(<FundDetail />)} />
      <Route path="/assets" element={protect(<Assets />)} />
      <Route path="/investments" element={protect(<Investments />)} />
      <Route path="/audit-logs" element={protect(<AuditLogs />)} />
      <Route path="/users" element={protect(<UserManagement />)} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
